module.exports = __webpack_public_path__ + "img/bongalo_fav_new.4c534b55.svg";